import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Calendar, User } from "lucide-react";
import { api } from "@/lib/api";

export default function JournalPost() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/posts/${id}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="pt-40 pb-24 px-6 text-center">
        <p className="text-monarch-ash">Post not found.</p>
        <Link to="/journal" className="btn-outline-gold mt-6 inline-flex">Back to Journal</Link>
      </div>
    );
  }
  if (!post) return <div className="pt-40 pb-24 px-6 text-center text-monarch-ash">Loading…</div>;

  return (
    <article data-testid="journal-post-page" className="pt-32 pb-24 px-6 md:px-10">
      <div className="mx-auto max-w-3xl">
        <Link to="/journal" data-testid="post-back-link" className="text-xs uppercase tracking-[0.25em] text-monarch-gold hover:text-monarch-champagne flex items-center gap-2 mb-10">
          <ArrowLeft className="w-3.5 h-3.5" /> Back to the Journal
        </Link>
        <div className="flex flex-wrap items-center gap-5 text-[10px] uppercase tracking-[0.3em] text-monarch-ash mb-5">
          <span className="flex items-center gap-2"><Calendar className="w-3.5 h-3.5 text-monarch-gold" /> {post.date}</span>
          <span className="flex items-center gap-2"><User className="w-3.5 h-3.5 text-monarch-gold" /> {post.author}</span>
        </div>
        <h1 data-testid="post-title" className="font-serif text-4xl md:text-5xl text-monarch-cream leading-[1.05] mb-10">{post.title}</h1>
        <div className="img-zoom aspect-[16/9] mb-12">
          <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
        </div>
        <div className="prose prose-invert max-w-none text-monarch-cream/85 leading-relaxed text-lg">
          <p>{post.body}</p>
        </div>
      </div>
    </article>
  );
}
